export default __webpack_public_path__ + "static/media/princess-logo-landing-horizontal.4077cab1.svg";